import AssetClassesList from './assetClassesList'

export default AssetClassesList
